import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/ns8': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M187.1 159.9h44.9l-48.5 160.1h-56.9l-50.6-106.5-31.1 106.5h-44.9l49-160.1h49.4l54.5 113.7zM639.6 159c4.6 28.6-36.1 44.7-65.7 50.6h-0.1c17.5 29.3 22.1 69.3 3.4 105.5-26.4 51.2-86.5 79.9-135.1 68-29.4-7.2-51.4-29-56.8-59.5-0.7-3.5-1-7.1-1.2-10.8-5.5 2.8-11.9 4.2-18.5 4.9-15.6 1.7-21 2.3-160.9 2.3l11.6-39.5h126.8c9.1 0 12.2-3.2 13.8-7.4 1.7-4.6 3.4-10.2 4.5-14.6 1.1-3.9 0.1-6.6-7.7-6.6h-87.3c-33.4 0-38.2-9.2-32.8-28.6 3.2-11.5 10.8-37.2 17.6-47.1 7.1-10.2 18.3-13.7 30.6-15 15.6-1.7 20.4-1.2 160.1-1.2l-9.7 31.5h-133.5c-5.5 0-11.2 0.7-13.3 7.1-1.8 5.4-2.1 6.7-3.7 12.2-1.4 5.1 2.2 7.4 11.5 7.4h87.6c20.4 0 31 6.8 34 16.6 19.9-21.4 50.4-39.5 94.2-48.2v-0.1c-13.4-42.5 43.9-66.6 88.5-58.8 18.2 3.2 39.2 13.3 42.1 31.3zM530.7 263.7c3.1-15.8-0.5-33.7-7.2-47.8-23.3 2.9-52.3 10.1-68.5 26.9-24.4 25.3-16.8 60 14.1 64.8 25 3.9 55.7-14.4 61.6-43.9zM552.5 180.6c10.6-1.5 23.5-3.5 34.2-9.6 14.8-8.5 10.4-21-4.9-24.4-10.9-2.4-25.1 0.5-31.8 7.7-7.3 7.8-1.7 20.3 2.5 26.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/ns8.js
// module id = 948
// module chunks = 0